export default "__VITE_ASSET__2fb4abdb__"